import { testimonials } from '@/mocks/home';

export default function Testimonials() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 text-accent-600 mb-3">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-double-quotes-l"></i>
            </span>
            <span className="text-xs font-semibold uppercase tracking-wider">读者好评</span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
            读者热评
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            听听他们怎么说——来自真实读者的声音
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <div className="flex flex-col gap-5 md:gap-6">
            <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-7 flex flex-col min-h-[220px]">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={testimonials[0].avatar} alt={testimonials[0].name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{testimonials[0].name}</div>
                  <div className="text-xs text-foreground-400">{testimonials[0].role}</div>
                </div>
                <div className="ml-auto text-accent-400 text-lg">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-double-quotes-l"></i>
                  </span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{testimonials[0].content}</p>
              <div className="flex gap-0.5 mt-3">
                {Array.from({ length: testimonials[0].rating }).map((_, i) => (
                  <span key={i} className="w-3.5 h-3.5 flex items-center justify-center text-accent-500">
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                ))}
              </div>
            </div>

            <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-7 flex flex-col min-h-[220px]">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={testimonials[1].avatar} alt={testimonials[1].name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{testimonials[1].name}</div>
                  <div className="text-xs text-foreground-400">{testimonials[1].role}</div>
                </div>
                <div className="ml-auto text-accent-400 text-lg">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-double-quotes-l"></i>
                  </span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{testimonials[1].content}</p>
              <div className="flex gap-0.5 mt-3">
                {Array.from({ length: testimonials[1].rating }).map((_, i) => (
                  <span key={i} className="w-3.5 h-3.5 flex items-center justify-center text-accent-500">
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden min-h-[460px] relative group">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20cozy%20reading%20scene%2C%20person%20reading%20comic%20on%20tablet%20in%20warm%20cafe%20with%20soft%20lighting%2C%20relaxed%20atmosphere%2C%20artistic%20manga%20style%2C%20rich%20warm%20amber%20tones%2C%20beautiful%20composition&width=600&height=800&seq=testimonial-feature&orientation=portrait"
              alt="韩漫阅读场景"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-black/10" />
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <div className="text-2xl font-bold font-heading text-white">{testimonials[2].name}</div>
              <div className="text-sm text-white/70 mt-1">{testimonials[2].role}</div>
              <p className="text-sm text-white/85 mt-3 leading-relaxed line-clamp-3">{testimonials[2].content}</p>
            </div>
          </div>

          <div className="flex flex-col gap-5 md:gap-6">
            <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-7 flex flex-col min-h-[220px]">
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{testimonials[3].content}</p>
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: testimonials[3].rating }).map((_, i) => (
                  <span key={i} className="w-3.5 h-3.5 flex items-center justify-center text-accent-500">
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                ))}
              </div>
              <div className="flex items-center gap-3">
                <span className="text-accent-400 text-lg">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-double-quotes-l"></i>
                  </span>
                </span>
                <div className="w-9 h-9 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={testimonials[3].avatar} alt={testimonials[3].name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{testimonials[3].name}</div>
                  <div className="text-xs text-foreground-400">{testimonials[3].role}</div>
                </div>
              </div>
            </div>

            <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-7 flex flex-col min-h-[220px]">
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{testimonials[4].content}</p>
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: testimonials[4].rating }).map((_, i) => (
                  <span key={i} className="w-3.5 h-3.5 flex items-center justify-center text-accent-500">
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                ))}
              </div>
              <div className="flex items-center gap-3">
                <span className="text-accent-400 text-lg">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-double-quotes-l"></i>
                  </span>
                </span>
                <div className="w-9 h-9 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={testimonials[4].avatar} alt={testimonials[4].name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{testimonials[4].name}</div>
                  <div className="text-xs text-foreground-400">{testimonials[4].role}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}